module.exports = __webpack_public_path__ + "static/media/3-VORR.2f5c26db.mp3";